/**
 * @generated SignedSource<<a63e14a41a6e55f8c16ea54e8c8a76a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoListItemProducts_WorkspaceProduct$data = ReadonlyArray<{
  readonly name: string | null;
  readonly " $fragmentType": "WorkspaceTodoListItemProducts_WorkspaceProduct";
}>;
export type WorkspaceTodoListItemProducts_WorkspaceProduct$key = ReadonlyArray<{
  readonly " $data"?: WorkspaceTodoListItemProducts_WorkspaceProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListItemProducts_WorkspaceProduct">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WorkspaceTodoListItemProducts_WorkspaceProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "WorkspaceProduct",
  "abstractKey": null
};

(node as any).hash = "679944d76951e235341f4cfe55c7f21a";

export default node;
